
















































import { defineComponent, computed, ref } from '@vue/composition-api';
// import { ProductSourceType } from '@tt4b/ttam-enums';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';
import ExpandButton from '@/components/common/expand-button/index.vue';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-product-source-type';
export default defineComponent({
  name,
  components: { TooltipInfo, ExpandButton },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onInput = (val: number) => {
      emit('change', val);
      emit('input', val);
    };

    const radioVal = computed({
      get() {
        return props.value;
      },
      set(val: number) {
        onInput(val);
      },
    });

    const isOnlyOne = computed(() => props.list.length <= 1);
    const isShowAll = computed(() => props.list.every(item => item.canShow));
    const expanded = ref(isShowAll.value || false);

    const onExpand = () => {
      trackEvent('module_ad_group_product_source_all_click');
      expanded.value = true;
    };

    return {
      name,
      isOnlyOne,
      isShowAll,
      expanded,
      radioVal,
      onInput,
      onExpand,
    };
  },
});
